
<div>
<iframe style="position: relative; height:550px; width: 98%; overflow: hidden;" rel="nofollow" [src]="safeSrc" loading="lazy">
</iframe> 
</div>
<!-- <iframe style="height: 500px; width: 99%;" src="about:blank">


<mat-card>
  <mat-card-content>
    <form #f1   id="f1" [formGroup]="form" [action]="this.getUrl()" >
      <h2>Log In</h2>
      
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Email" formControlName="username" required>
        
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput type="password" placeholder="Password" formControlName="password" required>
        
      </mat-form-field>
      <button #b1 mat-raised-button color="primary" (load)="this.callFormSubmit()">Login</button>
    </form>
  </mat-card-content>
</mat-card>


</iframe> -->


<!-- -
<object data="{{this.testSeriesUrl}}" width="600" height="400">
    <embed src="{{this.testSeriesUrl}}" width="600" height="400"/>
</object>

--->